import { render } from "./Skeletons.vue?vue&type=template&id=45b11351&scoped=true"
import script from "./Skeletons.vue?vue&type=script&lang=js"
export * from "./Skeletons.vue?vue&type=script&lang=js"

import "./Skeletons.vue?vue&type=style&index=0&id=45b11351&scoped=true&lang=scss"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b11351"]])

export default __exports__